import React, { useState } from "react";
import { useTranslation } from "../../i18n/useTranslation";
import { Typography, Table, Button, Modal } from "antd";
import DeviceDetailContent from "./DeviceDetail";

const { Text } = Typography;

const statusTagClass = (status) => {
  if (status === "Active") return "bg-green-50 text-green-700";
  if (status === "Inactive") return "bg-gray-100 text-gray-600";
  if (status === "Revoked") return "bg-red-50 text-red-600";
  return "bg-gray-100 text-gray-600";
};

const Devices = () => {
  const { t } = useTranslation();
  const [detailDevice, setDetailDevice] = useState(null);

  const deviceData = [
    {
      key: "1",
      deviceName: "Jetson-01",
      deviceId: "8a7b6c****1d2e3f",
      statusKey: "Active",
      lastUsed: "2026-01-16 09:10",
      boundAt: "2025-06-01 18:10",
      sdkVersion: "v3.2.1",
      revoked: false,
    },
    {
      key: "2",
      deviceName: "PC-Workstation",
      deviceId: "9d8e7f****2c3b4a",
      statusKey: "Inactive",
      lastUsed: "2026-01-15 18:30",
      boundAt: "2025-08-15 10:20",
      sdkVersion: "v3.1.0",
      revoked: false,
    },
    {
      key: "3",
      deviceName: "Test-Device-03",
      deviceId: "7c6d5e****3b4a59",
      statusKey: "Revoked",
      lastUsed: "2026-01-10 12:00",
      boundAt: "2025-09-01 09:00",
      sdkVersion: "v3.0.0",
      revoked: true,
    },
  ];

  const deviceColumns = [
    { title: t("deviceName"), dataIndex: "deviceName", key: "deviceName" },
    { title: t("deviceId"), dataIndex: "deviceId", key: "deviceId" },
    {
      title: t("deviceStatus"),
      dataIndex: "statusKey",
      key: "status",
      render: (statusKey) => (
        <span className={`inline-block px-2 py-0.5 rounded text-xs ${statusTagClass(statusKey)}`}>
          {t(`status${statusKey}`)}
        </span>
      ),
    },
    { title: t("lastUsedTime"), dataIndex: "lastUsed", key: "lastUsed" },
    { title: t("boundTime"), dataIndex: "boundAt", key: "boundAt" },
    { title: t("sdkVersion"), dataIndex: "sdkVersion", key: "sdkVersion" },
    {
      title: t("orderAction"),
      key: "action",
      render: (_, record) => (
        <span>
          <a
            href="#"
            className={record.revoked ? "text-gray-400 cursor-not-allowed" : "text-[#1890ff] hover:underline"}
            onClick={(e) => record.revoked && e.preventDefault()}
          >
            {t("deviceUnbind")}
          </a>
          <span className="text-gray-300"> | </span>
          <a
            href="#"
            className={record.revoked ? "text-gray-400 cursor-not-allowed" : "text-[#1890ff] hover:underline"}
            onClick={(e) => record.revoked && e.preventDefault()}
          >
            {t("deviceRename")}
          </a>
          <span className="text-gray-300"> | </span>
          <button
            type="button"
            className="text-[#1890ff] hover:underline bg-transparent border-none cursor-pointer p-0"
            onClick={() => setDetailDevice(record)}
          >
            {t("deviceViewDetail")}
          </button>
        </span>
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-[#004b67]">{t("licenseTitle")}</h1>
        <div className="mt-2 h-px bg-[#e6f7ff]" />
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5">
        <h2 className="text-sm font-medium text-gray-500 mb-4">{t("licenseInfo")}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("licenseId")}</Text>
            <Text strong>LIC2025060100001</Text>
          </div>
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("licenseScope")}</Text>
            <Text>{t("licenseScopeEdge")}</Text>
          </div>
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("lastRefresh")}</Text>
            <Text>2026-01-16 09:20 (GMT+8)</Text>
          </div>
          <div className="flex justify-between items-center">
            <Text type="secondary">{t("licenseValidPeriod")}</Text>
            <Text>2025-06-01 ~ 2026-06-01</Text>
          </div>
          <div className="flex justify-between items-center md:col-span-2">
            <Text type="secondary">{t("ticketEpochVersion")}</Text>
            <Text>v2.1.0 / 1736890000</Text>
          </div>
        </div>
        <div className="flex flex-wrap gap-2 pt-3 border-t border-gray-100">
          <Button type="primary">{t("btnRefreshLicense")}</Button>
          <Button>{t("btnDownloadLicense")}</Button>
          <Button>{t("btnCopyActivationCode")}</Button>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-100 p-5">
        <h2 className="text-sm font-medium text-gray-500 mb-4">{t("deviceBinding")}</h2>
        <Table
          dataSource={deviceData}
          columns={deviceColumns}
          pagination={false}
          size="middle"
        />
        <p className="text-sm text-gray-500 mt-4">{t("licenseRebindRule")}</p>
      </div>

      <Modal
        open={!!detailDevice}
        onCancel={() => setDetailDevice(null)}
        footer={null}
        width={720}
        centered
        destroyOnClose
        maskStyle={{ backgroundColor: "rgba(0,0,0,0.45)" }}
        styles={{ body: { paddingTop: 16 } }}
        className="device-detail-modal"
      >
        {detailDevice && <DeviceDetailContent device={detailDevice} />}
      </Modal>
    </div>
  );
};

export default Devices;
